import ChangedPasswordFormModal from './ChangedPasswordFormModal';

export default ChangedPasswordFormModal;


// WEBPACK FOOTER //
// ./src/components/ChangedPasswordFormModal/index.jsx